export default {
  userInfo: {}, // 用户信息
  courseBaseData: {}, // 课程基本信息：id、name、type...
  courseSimpleData: {}, // 满减时的默认的课程信息，课时，开课时间，sku，优惠价格
  currentEnv: '', // 当前共3个值：test/dev/pre；值为空时，则为线上
  loginControl: {
    show: false,
    event: null, // 登录成功后需处理的事件;数据示例：{handle: buy/备考意向, type: handle操作类型，此值做传出使用;}
  }, // 登录弹窗显示控制以及事件处理
  buyStatus: [], // 当前产品详情页主产品是够购买
  buyStatusForCourseList: [], // 为判断课程列表是否可点击保存课程购买状态
  productSku: {}, // 用户选的sku信息
  allAcvitity: {
    activeType: -1,
    nowAcvitity: {},
  }, // 产品详情页所有的活动信息
  containCurriculumData: {}, // 当前课表中的数据
  currentTime: '',
  addressInfo: {}, // 地址信息

  currentYear: {
    code: 8,
    value: '24考研',
  }, // 默认选择的考季
  userPhone: '', // 用户手机号,
  actionType: 0, // 判断登录
  courseInfo: {}, // 公开课信息
  groupBuyDetailVuex: {}, // 拼团详情
  bilibiliOrderDetails: {}, // b站订单详情
};
